import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { storeApi } from '../services/stores'
import { stampApi } from '../services/stamps'
import { rewardsApi } from '../services/rewards'
import { usersApi } from '../services/users'
import { rtkQueryErrorLogger } from '../services/errorMidlaware'
import errorSlice from './ErrorSlice'
import {authApi} from "../services/auth";
import authReducer from './AuthSlice'

const rootReducer = combineReducers({
  authApi: authApi.reducer,
  storeApi: storeApi.reducer,
  stampApi: stampApi.reducer,
  rewardsApi: rewardsApi.reducer,
  usersApi: usersApi.reducer,
  auth: authReducer,
  errorSlice: errorSlice,
})

export type RootState = ReturnType<typeof rootReducer>

const apiConfigured = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(storeApi.middleware)
      .concat(stampApi.middleware)
      .concat(rewardsApi.middleware)
      .concat(usersApi.middleware)
      .concat(rtkQueryErrorLogger),
})

export default apiConfigured
